<script lang="ts" setup></script>

<template>
    <div class="w-100 space-section-inner light overflow-y-hidden">
        <slot />
    </div>
</template>
